import CEOMessage from "@/components/enfinity/about-us/CEOMessage";
import AboutUsHeader from "@/components/enfinity/about-us/Header";
import WhyChooseUs from "@/components/enfinity/about-us/WhyChooseUs";
import OurTeam from "@/components/enfinity/OurTeam";
import Team from "@/components/enfinity/Team";
import CTA from "@/components/enfinity/CTA";
import Footer from "@/components/enfinity/Footer";
import Built from "@/components/enfinity/Built";
import { useEffect } from "react";

export default function EnfinityAboutUsEnfiniPay() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="bg-[#111111]">
      <AboutUsHeader />

      <Built />

      <WhyChooseUs />

      <OurTeam />

      <Team />

      <CEOMessage />

      <CTA />

      <Footer />
    </div>
  );
}
